/* รีวิว TikTok — กดการ์ดแล้วเปิด player ในหน้าต่างทับหน้าจอ
   เหตุที่ไม่ฝังในการ์ด: player ของ TikTok ต้องกว้าง >= 325px การ์ดบนคอมแคบกว่านั้น */
(function () {
  if (window.__sdstReviewInit) return;   // section รีวิว+เบื้องหลัง ใส่สคริปต์ตัวเดียวกัน
  window.__sdstReviewInit = true;

  var modal, frame, closeBtn, lastFocus;

  function build() {
    modal = document.createElement('div');
    modal.className = 'sdst-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'คลิปรีวิว TikTok');
    modal.hidden = true;
    modal.innerHTML =
      '<div class="sdst-modal__backdrop" data-close></div>' +
      '<div class="sdst-modal__box">' +
        '<button class="sdst-modal__close" type="button" data-close aria-label="ปิด">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
          'stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button>' +
        '<div class="sdst-modal__player"></div>' +
      '</div>' +
      '<a class="sdst-modal__src" hidden target="_blank" rel="noopener">' +
        '<span class="sdst-modal__srclabel">ดูโพสต์ต้นฉบับบน TikTok</span>' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
        'stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M7 17L17 7M9 7h8v8"/></svg>' +
      '</a>';
    document.body.appendChild(modal);
    closeBtn = modal.querySelector('.sdst-modal__close');
    modal.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-close')) close();
    });
  }

  function open(vid, plat, opt) {
    if (!modal) build();
    opt = opt || {};
    lastFocus = document.activeElement;
    var box = modal.querySelector('.sdst-modal__player');
    var src = modal.querySelector('.sdst-modal__src');
    // ลิงก์ไปโพสต์ต้นฉบับ — iOS/Android ที่มีแอป TikTok จะเปิดแอปให้เอง (universal link)
    var boxEl = modal.querySelector('.sdst-modal__box');
    boxEl.style.aspectRatio = ''; boxEl.style.width = '';
    if (plat !== 'youtube' && opt.url) {
      src.href = opt.url; src.hidden = false;
      src.querySelector('.sdst-modal__srclabel').textContent = opt.label || 'ดูโพสต์ต้นฉบับบน TikTok';
    }
    else { src.removeAttribute('href'); src.hidden = true; }
    if (plat !== 'youtube' && opt.src) {
      // ไฟล์ของเราเอง — เล่นได้แม้คลิปติดตะกร้า (embed ของ TikTok ถูกล็อก)
      var v = document.createElement('video');
      v.src = opt.src;
      if (opt.poster) v.poster = opt.poster;
      // คลิปจัตุรัส/แนวนอน → กรอบเปลี่ยนตามคลิป ไม่มีขอบดำ
      v.addEventListener('loadedmetadata', function () {
        if (v.videoWidth && v.videoHeight && v.videoWidth / v.videoHeight > 0.7) {
          boxEl.style.aspectRatio = v.videoWidth + ' / ' + v.videoHeight;
          boxEl.style.width = 'min(560px, 92vw)';
        }
      });
      v.controls = true; v.autoplay = true; v.playsInline = true;
      v.setAttribute('playsinline', ''); v.preload = 'auto';
      modal.querySelector('.sdst-modal__box').classList.remove('is-wide');
      box.appendChild(v);
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
      closeBtn.focus();
      document.addEventListener('keydown', onKey);
      return;
    }
    frame = document.createElement('iframe');
    if (plat === 'youtube') {
      frame.src = 'https://www.youtube-nocookie.com/embed/' + vid + '?autoplay=1&rel=0';
      modal.querySelector('.sdst-modal__box').classList.add('is-wide');
    } else {
      frame.src = 'https://www.tiktok.com/player/v1/' + vid +
                  '?autoplay=1&music_info=0&description=0&rel=0';
      modal.querySelector('.sdst-modal__box').classList.remove('is-wide');
    }
    frame.allow = 'autoplay; fullscreen; encrypted-media; picture-in-picture';
    frame.setAttribute('allowfullscreen', '');
    frame.title = 'คลิปรีวิว TikTok';
    box.appendChild(frame);
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    closeBtn.focus();
    document.addEventListener('keydown', onKey);
  }

  function close() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    modal.querySelector('.sdst-modal__player').innerHTML = ''; // หยุดเสียงทันที
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onKey);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKey(e) { if (e.key === 'Escape') close(); }

  // ราง TikTok/IG บนเดสก์ท็อป: ปุ่ม ‹ › เมื่อคลิปเกินจอ
  function railNav(track) {
    var nav = document.createElement('div');
    nav.className = 'sdst__nav'; nav.hidden = true;
    nav.innerHTML =
      '<button class="sdst__navbtn" type="button" data-dir="-1" aria-label="คลิปก่อนหน้า">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" ' +
        'stroke-linecap="round" stroke-linejoin="round"><path d="M15 6l-6 6 6 6"/></svg></button>' +
      '<button class="sdst__navbtn" type="button" data-dir="1" aria-label="คลิปถัดไป">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" ' +
        'stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg></button>';
    track.parentNode.insertBefore(nav, track);
    var prev = nav.children[0], next = nav.children[1];
    function update() {
      track.classList.remove('is-fit');
      var over = track.scrollWidth - track.clientWidth > 4;
      var desk = window.matchMedia('(min-width: 750px)').matches;
      if (!over && desk) track.classList.add('is-fit');   // คลิปน้อย = เต็มแถวพอดี ไม่ต้องเผื่อที่โผล่
      over = track.scrollWidth - track.clientWidth > 4;
      nav.hidden = !over;
      prev.disabled = track.scrollLeft < 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    nav.addEventListener('click', function (e) {
      var b = e.target.closest('.sdst__navbtn'); if (!b) return;
      var card = track.querySelector('.sdst-card');
      var step = card ? card.getBoundingClientRect().width + 22 : track.clientWidth * .8;
      track.scrollBy({ left: step * Number(b.getAttribute('data-dir')), behavior: 'smooth' });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init() {
    document.querySelectorAll('.sdst__track--vert').forEach(railNav);
    document.querySelectorAll('.sdst-card__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var vid = btn.getAttribute('data-vid');
        var plat = btn.getAttribute('data-plat') || 'tiktok';
        var ok = plat === 'youtube' ? /^[\w-]{6,20}$/.test(vid) : /^\d+$/.test(vid);
        var opt = { src: btn.getAttribute('data-src'), poster: btn.getAttribute('data-poster'),
                    url: btn.getAttribute('data-url'), label: btn.getAttribute('data-src-label') };
        if (opt.src && plat !== 'youtube') { open(vid, plat, opt); return; }
        if (vid && ok) open(vid, plat, opt);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
